// extracted by mini-css-extract-plugin
export default {"defaultTooltipType":"tooltip_defaultTooltipType__AaIFW","itemsTooltipType":"tooltip_itemsTooltipType__UOOJ9","overlayWrapper":"tooltip_overlayWrapper__XRJ4t"};